<template>
  <div class="data-grid-search-conditions">
    <el-collapse-transition v-if="initSearchCondition">
      <div v-show="searchExpend"
           class="conditions-wrap">
        <transition-group class="condition-list clearfix"
                          name="el-zoom-in-top"
                          tag="ul">
          <li v-for="searchCondition in searchConditions"
              :key="searchCondition.key">
            <div class="condition-wrap theme-bg theme-border">
              <span class="label">{{searchCondition.label}}：</span>
              <span class="value">
                <template v-if="searchCondition.group">
                  <template v-if="!searchCondition.condition || searchCondition.condition.data">
                    <span class="item"
                          v-for="(item, index) in searchCondition.value"
                          :key="'item-' + index">
                      <el-tooltip content="点击清除" placement="top">
                        <span @click="delKeyItem(searchCondition, index)">{{item | toValue}}</span>
                      </el-tooltip>
                    </span>
                  </template>
                  <template v-else>
                    <span class="icon">
                      <el-tooltip :class="['wrapper', {'is-word': searchCondition.condition.word}]"
                                  :content="searchCondition.condition.text"
                                  placement="top">
                        <span>{{searchCondition.condition.char}}</span>
                      </el-tooltip>
                    </span>
                  </template>
                </template>
                <template v-else>
                  <template v-if="searchCondition.condition">
                    <span class="icon">
                      <el-tooltip :class="['wrapper', {'is-word': searchCondition.condition.word}]"
                                  :content="searchCondition.condition.text"
                                  placement="top">
                        <span>{{searchCondition.condition.char}}</span>
                      </el-tooltip>
                    </span>
                    <span v-if="searchCondition.condition.data">
                      {{searchCondition.value}}
                    </span>
                  </template>
                  <span v-else>{{searchCondition.value}}</span>
                </template>
              </span>
              <i class="el-icon-close" @click="dealKey(searchCondition)"></i>
            </div>
          </li>
          <li v-if="$slots.append"
              :key="'last-item'">
            <slot name="append"></slot>
          </li>
        </transition-group>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  name: 'DataGridSearchCondition',
  props: {
    searchConditions: {
      type: Array,
      required: true
    },
    searchExpend: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      initSearchCondition: false
    }
  },
  filters: {
    toValue (item) {
      if (Array.isArray(item)) {
        return item.join(' / ')
      }
      return item
    }
  },
  methods: {
    delKeyItem (searchCondition, index) {
      this.$emit('del-key-item', searchCondition, index)
    },
    dealKey (searchCondition) {
      this.$emit('del-key', searchCondition)
    }
  },
  mounted () {
    this.$nextTick(() => {
      // 取消初始化过渡效果
      this.initSearchCondition = true
    })
  }
}
</script>

<style lang="scss">
  @use "../../../styles/common" as *;
  .data-grid-search-conditions {
    & > .conditions-wrap {
      padding: 0 15px 10px;
      & > .condition-list {
        list-style: none;
        margin: -5px;
        padding: 0;
        display: inline-block;
        & > li {
          float: left;
          margin: 5px;
          & > .condition-wrap {
            position: relative;
            color: #fff;
            font-size: 12px;
            height: 26px;
            line-height: 24px;
            padding: 0 24px 0 10px;
            border: 1px solid transparent;
            border-radius: 3px;
            box-sizing: border-box;
            overflow: hidden;
            & > .value {
              & > .item {
                position: relative;
                cursor: pointer;
                & + .item {
                  margin-left: 16px;
                  &:before {
                    content: '';
                    position: absolute;
                    left: -8px;
                    top: 8px;
                    width: 1px;
                    height: 9px;
                    margin-top: -4px;
                    background-color: rgba(255,255,255,.75);
                  }
                }
              }
              & > .icon {
                display: inline-block;
                width: 16px;
                height: 16px;
                font-size: 12px;
                background: rgba(255,255,255,.3);
                border-radius: 2px;
                vertical-align: -3px;
                border: 1px solid rgba(255,255,255,.08);
                box-sizing: border-box;
                position: relative;
                & > .wrapper {
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%,-50%) scale(.72);
                  cursor: pointer;
                  &:not(.is-word) {
                    transform: translate(-50%,-50%) scale(.9);
                    @extend .console-font;
                  }
                }
              }
            }
            .el-icon-close {
              position: absolute;
              right: 5px;
              top: 50%;
              transform: translateY(-50%);
              opacity: .75;
              cursor: pointer;
              &:hover {
                opacity: 1;
              }
            }
          }
          & > .el-button {
            height: 26px;
            line-height: 24px;
            padding: 0 10px;
            box-sizing: border-box;
            vertical-align: top;
            & + .el-button {
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
</style>
